import { _, helpers, ts } from '_core';

import { DraftParams } from './types';
import { getBenchmarkTitle } from '../../common/utils/get-name';

export const prepareLagData = (tableData: ts.types.widgets.TableData, isBenchmark = false) => {
  const localTableData = tableData.map((item) =>
    Object.fromEntries(
      Object.entries(item).map(([key, value]) => [key.replace('residual_alpha', 'Residual Alpha'), value])
    )
  );

  if (!isBenchmark) return localTableData;

  const newData = localTableData.map((item) => {
    const newItem = { date: item.date } as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key.endsWith('_active')) {
        newItem[key.replace('_active', '')] = Number(item[key]) * 100;
      }
    });
    return newItem;
  });
  return newData;
};

export const validate = (params: DraftParams) => {
  const rhErrors = helpers.validations.validSelectedReturnHorizon(params?.return_horizon);
  if (!_.isEmpty(rhErrors)) return rhErrors;
  if (!params.lags || params.lags < 1 || params.lags > 12) return ['Lags is invalid.'];
  if (params.with_benchmark && !helpers.validations.validBenchmark(params.benchmark)) return ['Benchmark is invalid.'];
  return [];
};

export const getName = (
  params: DraftParams,
  _context: ts.types.signal.SignalAnalysisContext,
  resources: ts.StoreState['resources']
) => {
  if (params.benchmark)
    return getBenchmarkTitle(params.benchmark, `${'Cumulative Returns With Lags'}`, resources.universes);
  return 'Cumulative Returns With Lags';
};
